import { createContext, useContext, type ReactNode } from "react";

const EditModeContext = createContext(false);

export function EditModeProvider({
  editMode,
  children,
}: {
  editMode: boolean;
  children: ReactNode;
}) {
  return (
    <EditModeContext.Provider value={editMode}>
      {children}
    </EditModeContext.Provider>
  );
}

export function useEditMode() {
  return useContext(EditModeContext);
}
